import { CONTEXT_TYPES, ImageDTO, ListDTO } from "api/bookAppointmentOnline/get-book-appointment-dashboard-items";
import { formatPrice } from "helpers/format-price.helper";
import { formatTimeMinutesHours } from "helpers/format-time-minutes-hours.helpers";

export class BookAppointmentOnlineItemModel {
    private title: string;
    private subtitle?: string;
    private priceFrom?: string;
    private priceTo?: string;
    private durationFrom?: string;
    private durationTo?: string;
    private context: CONTEXT_TYPES;
    private contextId: string;
    private images?: ImageDTO[];

    constructor(definition: ListDTO) {
        Object.keys(definition).forEach((name: string) => {
            this[name] = definition[name];
        });
    }

    public getTitle(): string {
        return this.title;
    }
    public getSubtitle(): string | null {
        return this.subtitle;
    }
    public getPriceFrom(): string | null {
        return this.priceFrom;
    }
    public getPriceTo(): string | null {
        return this.priceTo;
    }
    public getFormattedPrice(): string | null {
        if (!this.priceFrom && !this.priceTo) return null;
        if (!this.priceTo || this.priceFrom === this.priceTo) return formatPrice(this.priceFrom ?? this.priceTo);
        if (!this.priceFrom) return formatPrice(this.priceTo);
        return `${formatPrice(this.priceFrom)} - ${formatPrice(this.priceTo)}`;
    }
    public getDurationFrom(): string | null {
        return this.durationFrom;
    }
    public getDurationTo(): string | null {
        return this.durationTo;
    }
    public getFormattedDuration(): string | null {
        if (!this.durationFrom && !this.durationTo) return null;
        if (!this.durationTo || this.durationFrom === this.durationTo) {
            return formatTimeMinutesHours(Number(this.durationFrom ?? this.durationTo));
        }
        if (!this.durationFrom) return formatTimeMinutesHours(Number(this.durationTo));
        return `${formatTimeMinutesHours(Number(this.durationFrom))} - ${formatTimeMinutesHours(Number(this.durationTo))}`;
    }
    public getContext(): CONTEXT_TYPES {
        return this.context;
    }
    public getContextId(): string {
        return this.contextId;
    }
    public getImages(): ImageDTO[] {
        return this.images ?? [];
    }

}
